export default {
  en: {
    keyword: 'Keyword',
    select: 'Select',
    code: 'Code',
    name: 'Name',
    includeBreakfast: 'Include<br />Breakfast',
    yes: 'Yes',
    no: 'No',
    period: 'Period',
    room: 'Room',
    viewRate: 'View Rate',
    selectedVersion: 'Selected versions',
    latestVersion: 'Latest versions',
    updatedRateCodeMessage: 'This rate code has been updated',
    deletedRateCodeMessage: 'This rate code has been deleted'
  },
  th: {
    keyword: 'คำที่ต้องการค้นหา',
    select: 'เลือก',
    code: 'รหัส',
    name: 'ชื่อ',
    includeBreakfast: 'รวม<br />อาหารเช้า',
    yes: 'ใช่',
    no: 'ไม่',
    period: 'ช่วงเวลาทั้งหมด',
    room: 'ห้องทั้งหมด',
    viewRate: 'ดูเรท',
    selectedVersion: 'ข้อมูลที่เลือก',
    latestVersion: 'ข้อมูลล่าสุด',
    updatedRateCodeMessage: 'เรทนี้มีการแก้ไข',
    deletedRateCodeMessage: 'เรทนี้ถูกลบไปแล้ว'
  }
}
